// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxZy99eIxh0rjn8O8KDrfIX07ldMJYQyk",
  authDomain: "thousand-crane.firebaseapp.com",
  databaseURL:
    "https://thousand-crane-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "thousand-crane",
  storageBucket: "thousand-crane.appspot.com",
  messagingSenderId: "597500439180",
  appId: "1:597500439180:web:bc55a53d3c7d9b41d829a9",
  measurementId: "G-N1MFB11MFM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const firestore = getFirestore(app);
const auth = getAuth();

export { analytics, firestore, auth };
